import * as React from "react"
import * as ReactDom from "react-dom"
import * as Bouncer from "formbouncerjs";
import Register from "../components/views/Register";
import { emails } from "../config/constants";
import { checkLang, setCurrentPage } from "../services/general";
import { requestPageData } from "../services/api";

export const page = async () => {
    const registerContainer = document.getElementById('register')
    const REGISTERYINFO = window.drupalSettings.react.node || await requestPageData({ content: "partner", nid: registerContainer.dataset.nid, langcode: checkLang() })
    ReactDom.render(<Register  data={REGISTERYINFO} />, registerContainer)
    setNewForm()
    validateForm()
    setCurrentPage('register')
}

function setNewForm() {
    const refForm = document.getElementById('refFormRegister')
    const refNewForm = document.getElementById('newFormRegister')

    refNewForm.insertAdjacentElement('beforeend', refForm.children[0])

    refForm.remove()
}

function validateForm() {
    let validationsMessages: any = {
        field: 'Campo Obligatorio',
        email: 'Por favor ingrese un email válido',
        phone: 'Solo se permiten 7 a 10 digitos',
        tyc: 'Debe aceptar términos y condiciones'
    }
    var validate = Bouncer("#mx-aguas-firmes-register-form", {
        patterns: {
            email:
                /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
        },
        customValidations: {
            emailVerified: function (field: any) {
                let array_email = field.value.split("@");
                const res = emails.find((m) => m === array_email[1]);
                return res === undefined ? false : true;
            },
            phoneVerified: function (field: any) {
                if (field.name == "cellphone" || field.name == "cellphone_en") {
                    if (field.hasAttribute('required')) {
                        const value = field.value;
                        if (value.length < 7 || value.length > 10) {
                            return true;
                        }
                    }
                }
            },
            anotherVerified: function (field: any) {
                if(field.name == "other") return true;
            }
        },
        messages: {
            missingValue: {
                default: validationsMessages.field,
                checkbox: validationsMessages.tyc,
            },
            emailVerified: validationsMessages.email,
            phoneVerified: validationsMessages.phone,
            anotherVerified: validationsMessages.field,
            patternMismatch: {
                email: validationsMessages.email,
            },
        },
    });
}